import { Component, input } from '@angular/core';

@Component({
  selector: 'app-primeng-toast',
  template: `
    <p-toast [position]="position()"></p-toast>
  `,
  styles: [],
  standalone: false,
})
export class PrimengToastComponent {
  position = input<'top-right' | 'top-left' | 'bottom-right' | 'bottom-left' | 'top-center' | 'bottom-center' | 'center'>('top-right');
}
